import htmlTemplate from "./activity_duration.html";
import angular from "angular";

export default angular
    .module("sbApp.common.components.activityDuration", [])
    .component("sbActivityDuration", {
        templateUrl: htmlTemplate,
        bindings: {
            parent: "<",
            activity: "<?",
        },
        controller: function ActivityCommonInputCtrl(
            ACTIVITY_CONFIG,
            TEMPLATE_WORK_DONE_UNITS
        ) {
            "ngInject";
            var vm = this;

            vm.CONFIG = ACTIVITY_CONFIG;
            vm.UNITS = TEMPLATE_WORK_DONE_UNITS;
        },
    });
